<template>
  <div class="programming">
    <div class="programming_left" ref="programming_left" :style="leftDivStyle">
      <div class="header">
        <span class="el-icon-back" @click="goBack"></span>
        <span>{{resourceName}}</span>
      </div>
      <div class="bottomer">
        <div class="nava">
          <div class="nava_tool">
            <p @click="nava_tool_click(0)" :class="{activeP: toolTab === 0}">
              <span class="el-icon-tickets" style="font-size: 22px;"></span>
              <span class="nava_label">步骤</span>
            </p>
            <p @click="nava_tool_click(1)" :class="{activeP: toolTab === 1}">
              <span class="el-icon-tickets" style="font-size: 22px;"></span>
              <span class="nava_label">评分</span>
            </p>
            <p @click="nava_tool_click(2)" :class="{activeP: toolTab === 2}">
              <span class="el-icon-notebook-1" style="font-size: 22px;"></span>
              <span class="nava_label">笔记</span>
            </p>
          </div>
          <div class="nava_menu" :class="{activeNava: toolTab === 0}">
            <div class="nava_menu_style">
              <p
                v-for="(item, index) in treeData"
                :key="index"
                :class="{ activeRound: activeIndex == index }"
                @click="activeThisOne(item, index)"
              >
                <span class="item_round" :class="{ item_activeRound: activeIndex == index }">{{index + 1}}</span><span>{{ item.name }}</span>
              </p>
            </div>
          </div>
          <div class="nava_menu" :class="{activeNava: toolTab === 1}">
            <div class="rateBox" v-if="stepWeight">
              <div style="padding-right: 10px;font-size: 12px;">得分:</div>
              <el-rate
                v-model="stepWeight"
                disabled
                show-score
                text-color="#ff9900"
                score-template="{value}">
              </el-rate>
            </div>
            <div class="nava_menu_style">
              <template v-for="(item, index) in treeData">
                <div
                  :key="index"
                  v-if="item.itData"
                  :class="{ activeRound: activeIndex == index }"
                >
                  <el-collapse v-model="activeNames">
                    <el-collapse-item :name="index">
                      <template slot="title">
                        <span class="item_round">{{index + 1}}</span>
                        <span>{{ item.name }}</span>
                      </template>
                      <div v-for="(ititem, itindex) in item.itData" :key="itindex+'a'">
                        <p class="agreementP" v-for="(aitem, aindex) in ititem.agreementList" :key="aindex+'b'"
                           @click="activeThisOne(item, index)">
                        <span>
                            <span class="yuanqiu">{{ aindex+1 }}</span>
                            <span>{{ aitem.title }}</span>
                        </span>
                          <span>
                           <span v-if="aitem.unitWeight" class="el-icon-success" style="color: #67C23A"></span>
                           <span v-else class="el-icon-error" style="color: #F56C6C"></span>
                        </span>
                        </p>
                      </div>
                    </el-collapse-item>
                  </el-collapse>

                </div>
              </template>
            </div>
          </div>
          <div class="nava_note" :class="{activeNava: toolTab === 2}">
            <Note ref="programming_note"></Note>
          </div>
        </div>
        <div class="content" v-loading="loading">
          <div class="content_header activeRound">
            <span class="item_activeRound">{{activeIndex + 1}}</span>
            <span class="item_label">{{ activeOne.name || '前序' }}</span>
          </div>
          <div class="text_content">
            <div
              class="type6Item"
              v-for="(item, index) in activeOne.imageText"
              :key="index"
            >
              <template v-if="item">
                <div class="ql-editor" v-html="item.value" v-if="item.type === 1"></div>
                <questionRender
                  v-else-if="item.type === 3"
                  :question="item"
                  :questionAnswer="item.questionAnswer">
                </questionRender>
                <!--                <img :style="{'width': item.styleOption.width? item.styleOption.width + '%':'50%'}"-->
                <!--                     v-else-if="item.type === 7" class="type6resouce" :src="item.value"/>-->
                <el-image
                  v-else-if="item.type === 7"
                  :style="{
                  width: item.styleOption.width
                    ? item.styleOption.width + '%'
                    : '50%',
                }"
                  class="type6resouce"
                  :src="item.value"
                  :preview-src-list="[item.value]">
                </el-image>
                <video
                  :style="{
                           'width': item.styleOption.width + '%',
                        }"
                  v-else-if="item.type === 10"
                  class="video-js type6resouce"
                  controls
                  preload="auto"
                  controlslist="nodownload"
                  data-setup="{'example_option':true}"
                >
                  <source :src="item.value" type="video/mp4" class="video"/>
                  <p class="vjs-no-js">不支持播放</p>
                </video>

                <code-compiler
                  :readPage="true"
                  ref="codeCompiler"
                  readOnly
                  :refresh="item.value"
                  v-else-if="item.type === 11"
                  v-model="item.value"
                ></code-compiler>
                <div v-else-if="item.type === 12">
                  <el-popover
                    placement="bottom"
                    trigger="click"
                  >
                    <span class="zl_button zl_blueButton" @click="handleImport(item.value)">下 载</span>
                    <el-button size="mini" slot="reference">{{ item.value }}</el-button>
                  </el-popover>
                </div>
              </template>
            </div>
          </div>
          <!-- 正确率统计 -->
          <div class="eventScoring" v-if="activeOne.rightNumber || activeOne.errorNumber">
            <div class="eventScoringL" @click="openEventScoring">
              <span class="el-icon-arrow-down" v-if="eventScoring"></span>
              <span class="el-icon-arrow-up" v-else></span>
            </div>
            <div class="eventScoringContent" :class="{eventScoringShow:eventScoring}">
              <div class="eventScoringHead">
                <span class="eventScoringHeadItem"><span class="el-icon-success" style="color: #67C23A"></span><span
                  class="eventScoringHeadNumber" style=""> {{activeOne.rightNumber || 0}}</span></span>
                <span class="eventScoringHeadItem"><span class="el-icon-error" style="color: #F56C6C"></span><span
                  class="eventScoringHeadNumber"> {{activeOne.errorNumber || 0}}</span></span>
                <span class="eventScoringHeadItem"><span class="el-icon-menu" style="color: #999999"></span><span
                  class="eventScoringHeadNumber"> {{(activeOne.rightNumber + activeOne.errorNumber) || 0}}</span></span>
              </div>
              <div>
                <div v-for="(ititem, itindex) in activeOne.itData" :key="itindex+'a'">
                  <p class="agreementP" v-for="(item, index) in ititem.agreementList" :key="index+'b'">
                    <span>
                        <span class="yuanqiu">{{ index+1 }}</span>
                        <span>{{ item.title }}</span>
                    </span>
                    <span>
                       <span v-if="item.unitWeight" class="el-icon-success" style="color: #67C23A"></span>
                       <span v-else class="el-icon-error" style="color: #F56C6C"></span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="content_footer">
            <span v-if="activeIndex > 0" class="courseSubBtn zl_button zl_whiteButton" @click="prev">上一步</span>
            <span
              class="courseSubBtn zl_button zl_blueButton"
              @click="postMessage"
              style="margin:0 20px">
              {{ treeData.length == 1 || isEnd ? '测评' : activeOne.errorNumber ? '重新测评':'下一步'}}
            </span>
            <span v-if="activeOne.errorNumber && !isEnd" @click="next" class="skip">跳过</span>
            <span
              v-if="isEnd"
              @click="nextSection"
              class="nextSection">
              学习下一节
            </span>
          </div>
        </div>
        <div class="bottomerMask" v-if="toolTab >= 0" @click="toolTab = -1"></div>
      </div>
    </div>
    <div class="programming_line" @mousedown.stop="lineMove($event)">
          <span class="code_line_icon">
           <svg
             style="width: 20px; height: 13px;"
             class="icon svg-icon"
             aria-hidden="true"
           >
            <use xlink:href="#icon-tuozhuai1"></use>
          </svg>
        </span>
    </div>
    <div class="programming_right">
      <code-compiler v-if="showRightType === 0"
                     ref="taskCode"
                     task
                     :refresh="refresh"
                     style="width: 100%;height: 100%"
                     v-model="taskData"
      ></code-compiler>
      <div style="width: 100%;height: 100%;overflow: hidden;position: relative" v-else>
        <div class="toolsSet" >
          <el-tooltip v-if="showjuPyterTools" effect="light" content="设置" placement="left-start">
            <span class="el-icon-s-tools" @click="showjuPyterTools = false"></span>
          </el-tooltip>
          <div v-else class="toolsShowStyle">
            <el-tooltip effect="light" content="收起" placement="left-start">
              <span class="el-icon-setting" @click="showjuPyterTools = true"></span>
            </el-tooltip>
            <el-tooltip effect="light" :content="timeout?`请${timeout}秒后再重置`:'重置数据'" placement="left-start">
              <span class="el-icon-refresh" @click="jupyterReset" :style="{cursor: timeout ? 'not-allowed' : 'pointer'}"></span>
            </el-tooltip>
            <el-tooltip effect="light" :content="timeout?`请${timeout}秒后再重启`:'重启环境'" placement="left-start">
              <span class="el-icon-video-play" @click="jupyterRestart" :style="{cursor: timeout ? 'not-allowed' : 'pointer'}"></span>
            </el-tooltip>
          </div>
        </div>
        <it-loading ref="itLoading"></it-loading>
        <iframe
                style="position: absolute"
                ref="OSiframe"
                height="100%"
                width="100%"
                :src="iframeAddress"
                frameborder="0"
        ></iframe>
      </div>

    </div>

    <zl-rate :refresh="rateRefresh" v-model="stepWeight"></zl-rate>
    <temporary-interaction :common-data="getInteractionData()" :user-type="userType" :showToolsBox="showToolsBox" ></temporary-interaction>
    <office-re-edit :showToolsBox="showToolsBox && (String(userType) !== '2')"
                    :page-tools="{show:(activeOne.szrtType == 1 || activeOne.szrtType == 2 || activeOne.szrtType == 8 )}"
                    :upload-file-data="getUploadFileData()"
                    @prev="prev"
                    @next="next"
                    @openSide="openSide"
    >
    </office-re-edit>
  </div>
</template>

<script>
  import codeCompiler from "../../component/code_compiler";
  import Note from "./note";
  import questionRender from "../../component/questionRender";
  import paperPreview from "../../component/paperPreview";
  import * as api from "../../../api/newCourseApi";
  import * as sourceApi from "../../../api/sourceApi";
  import * as courseApi from "../../../api/courseApi";
  import qs from 'qs';
  import zlRate from "../../component/zl_rate";
  import officeReEdit from '@/views/szrt_revision/teachingDetail/list/classroom/officeReEdit'
  import TemporaryInteraction from "@/views/szrt_revision/teachingDetail/list/classroom/temporaryInteraction";
  import ItLoading from "@/views/szrt_revision/teachingDetail/list/classroom/itLoading";
  import {isLinuxLabOS, sendClipboardContent} from "@/utils/utils";
  export default {
    name: "programming",
    components: {
      ItLoading,
      codeCompiler, Note, questionRender, paperPreview, zlRate,officeReEdit,TemporaryInteraction
    },

    data() {
      return {
        showjuPyterTools:false,
        timeout:0,
        userType: sessionStorage.getItem("userType"), //
        showToolsBox:false,
        id: this.$route.query.id,
        catalogType: this.$route.query.catalogType,
        courseId: this.$route.query.courseId,
        classId: this.$route.query.classId,
        resourceName: '',
        leftDivStyle: {width: '40%'},
        iframeAddress: '',
        refresh: false,
        taskData: '',
        showRightType: -1,

        treeData: [],
        toolTab: -2,
        toolTabBak:-2,
        activeOne: {},
        activeIndex: -1,
        //
        answer: [],
        platform: '',
        templeteCode: '',
        questionId: '',
        roles: '',
        isDrag: false,
        //
        eventScoring: false,
        //
        loading: false,
        iframeLoading: false,

        isEnd: false, // 是否最后一步。展示跳到下一节的按钮
        activeNames: [], // 展开项
        stepWeight: 0, // 总分
        timer: null,
        //
        score: {},
        rateRefresh: false,
      }
    },
    watch: {
      activeIndex(val) {
        if (this.treeData.length) {
          if (val === this.treeData.length - 1) {
            this.isEnd = true;
          } else {
            this.isEnd = false;
          }
        } else {
          this.isEnd = true;
        }
      },
      iframeLoading(val){
        if (val){
          this.$refs.itLoading.playAnimation()
        }else {
          this.$refs.itLoading.nextAnimation()
        }
      }
    },
    computed:{
      getUploadFileData(){
        return function(){
          return {
            catalogId: this.id,
            classId: this.classId,
            courseId: this.courseId,
            userId:sessionStorage.getItem('userId')
          }
        }
      },
      getInteractionData() {
        return function () {
          return {
            catalogId: this.id,
            classId: this.classId,
            courseId: this.courseId,
            catalogType:this.catalogType
          }
        }
      },
    },
    created() {
      if (this.id) {
        this.loading = true;
        this.init()
        this.getJupyterTaskRecord() // 查之前的评分结果
        //如果是上课模式 则显示工具
        if (this.$route.query && this.$route.query.courseMold === 'startCourse'){
          this.showToolsBox = true
        }
      }
    },
    mounted() {
      let that = this;
      window.addEventListener('message', async (message) => {
        if (message.data) {
          // 获取从编译器评分后返回的数据
          if (message.data.form === 'score') {
            if (message.data.data) {
              let res = JSON.parse(message.data.data)
              if (res.code == 0) {
                that.resultScore(res.result);
              } else {
                that.next();
                that.$messageWarning(res.result)
              }
            }
            that.iframeLoading = false;
          } else if (message.data.form === 'ready') {
            console.log('programming ready==>环境初始化成功')
            that.iframeLoading = false;
            that.sendMsg()
          } else if (message.data.form === 'reset') {
            console.log('重置成功')
            that.iframeLoading = false;
          } else if (message.data.form === 'error') {
            that.$messageSuccess('工具初始化失败，请退出重试')
          }
          console.log('-由jupyter返回的数据', message.data)
        }
        that.loading = false;
      }, false);
    },
    beforeDestroy() {
      this.loading = false;
      this.iframeLoading = false;
      this.iframeAddress = "";
      this.activeNames = [];
      clearTimeout(this.timer);
    },
    methods: {
      // 重启。
      jupyterRestart() {
        if (this.timeout > 0) return;
        let r1 = '&restart=1'
        const iframeAddress = this.iframeAddress.replace(r1, '')
        this.iframeLoading = true;
        this.$nextTick(() => {
          this.iframeAddress = iframeAddress + r1
          console.log('jupyterRestart',this.iframeAddress)
        })
        this.setMTimeout()
      },
      // 重置。
      jupyterReset() {
        if (this.timeout > 0) return;
        let iframe = this.$refs.OSiframe;
        if (iframe && iframe.contentWindow) {
          let iframeWin = iframe.contentWindow;
          iframeWin.postMessage({gxzl: true, type: 'reset'}, this.iframeAddress);
          this.iframeLoading = true;
        }
        this.setMTimeout()
      },
      setMTimeout() {
        this.timeout = 30
        this.timeoutId = setInterval(() => {
          if (this.timeout > 0) {
            --this.timeout
          } else {
            this.clearMTimeoutInterval()
          }
        }, 1000)
      },
      clearMTimeoutInterval() {
        clearInterval(this.timeoutId)
        this.timeout = 0
      },
      sendMsg(){
        console.log('programming sendMsg')
        const requirement = () =>(isLinuxLabOS(this.platform) && this.iframeAddress)
        sendClipboardContent(this.$refs.OSiframe,requirement)
      },
      openSide(){
        this.nava_tool_click(this.toolTabBak)
      },
      getJupyterTaskRecord() {
        let param = {
          classId: this.classId,
          courseId: this.courseId,
          questionId: this.id,
        }

        api.getJupyterTaskRecord(param).then(res => {
          if (res.code == 0) {
            console.log('--res--', res.data)
          }
        })
      },
      openEventScoring() {
        this.eventScoring = !this.eventScoring;
      },
      init() {
        api.CategoryResourceFindById({id: this.id}).then(res => {
          if (res.code == 0) {
            if (res.data && res.data.imageText) {
              this.treeData = JSON.parse(res.data.imageText)
              this.resourceName = res.data.resourceName
              this.getImgText()
              this.getResourceQuestion(res.data.resourceId);
            }
          }
        })
      },
      getImgText() {
        let arr = [];
        let key = -1;
        if (this.treeData.length) {
          [].forEach.call(this.treeData, item => {
            if (item.extendOption && item.extendOption.indexText) {
              key++
              if (arr[key] && arr[key].length) {
                arr[key].push(item)
              } else {
                arr[key] = [item]
              }
            } else {
              if (key == -1) key++
              if (arr[key] && arr[key].length) {
                arr[key].push(item)
              } else {
                arr[key] = [item]
              }
            }
          })
          if (arr.length) {
            this.treeData = [];
            [].forEach.call(arr, item => {
              let o = {}
              o.name = item[0].extendOption.indexText || '首先';
              o.event = item[0].extendOption.event || '';
              o.imageText = item;
              this.treeData.push(o)
            })
            this.activeOne = this.treeData[0];
            this.activeIndex = 0;
          } else {
            this.treeData = [];
          }
        }

        this.loading = false;
      },
      getResourceQuestion(id) {
        sourceApi.getResourceQuestion(id).then(res => {
          if (res.code == "0") {
            if (res.data && res.data.questionId) {
              this.questionId = res.data.questionId;
              this.getAnswer(res.data.questionId)
            }
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      getAnswer(questionId) {
        courseApi.getAnswer(questionId).then(res => {
          if (res.code == 0) {
            if (res.data && res.data.questions && res.data.questions.questionAnswer) {
              this.answer = JSON.parse(res.data.questions.questionAnswer);
              this.answer[0].dynmaicParamReqList.forEach((item) => {
                if (item.param == "roles") {
                  this.roles = item.value;
                } else if (item.param == "templeteCode") {
                  this.templeteCode = item.value;
                } else if (item.param == "platform") {
                  this.platform = item.value;
                }
              });
              this.go_coder();
            }
          }
        })
      },
      go_coder() {
        this.iframeAddress = "";

        let productFlag = sessionStorage.getItem('productFlag'); //课程类型：1.课证融通、2.单项训练、3.综合实训、4.真实任务
        //  sourceId = examType_courseId_classId_examPlan_teamId_userId_courseType_setNumber;
        //  examType  2考试  3综合  4课证融通或单项  5测验  6大赛  15课证融通测评
        //  courseId  课程id，没有写 NONE
        //  classId   班级id，没有写 NONE
        //  examPlan   计划id 或者 考试id  没有写 NONE
        //  teamId    小组id，  没有写 NONE  与userId互斥
        //  userId    用户id，  没有写 NONE  与teamId互斥
        //  courseType   课程类型   1课程 2实训
        //  setNumber   重置次数，默认1

        let examType = 'NONE';
        if (productFlag === '1' || productFlag === '2'){  //课程类型：1.课证融通、2.单项训练
          examType = 4  // 4课证融通或单项
        }else if(productFlag === '3'){  //课程类型：3.综合实训
          examType = 3  // 3综合
        }

        let courseId = this.courseId || 'NONE';
        let classId = this.classId || 'NONE';
        let examPlan = 'NONE';
        let teamId = 'NONE';   // 测验里的测评没有小组，在综合实训中有。
        let userId = sessionStorage.getItem("userId");
        let courseType = this.catalogType || 'NONE';
        let setNumber = 1;

        let sourceId = `${examType}_${courseId}_${classId}_${examPlan}_${teamId}_${userId}_${courseType}_${setNumber}`;

        let params = {
          edu_token: localStorage.getItem("Authorization"),
          userId: sessionStorage.getItem("userId"),
          sourceId: sourceId,
          questionId: this.questionId,
          templeteCode: this.templeteCode,
          roleCodes: this.roles,
          timestamp: new Date().getTime(),
        };
        if (!this.platform) return this.$message.warning('该文本绑定的试题没有配置动态参数');
        if (this.platform === "codeBlockOS") {
          //代码块
          this.showRightType = 0;
        } else{
          if (this.platform === "jupyterNoteBook") {
            //  编辑器1
            this.iframeAddress =  process.env.VUE_APP_COS + "?" + qs.stringify(params);
          } else if (this.platform === "jupyterTerminals") {
            //   终端
            params['kernelType'] = 'terminals'
            this.iframeAddress = process.env.VUE_APP_COS + "?" + qs.stringify(params);
          } else if (this.platform === "liunxLabOS" || this.platform === "linuxLabOS") {
            //  编译器2
            params['kernelType'] = 'vnc'
            this.iframeAddress = process.env.VUE_APP_LINUXHUB + '/hub/login' + "?" + qs.stringify(params);
          }
          this.iframeLoading = true;
          this.showRightType = 1;
        }

      },
      nava_tool_click(type) {
        this.toolTabBak = type
        if (this.toolTab === type) {
          this.toolTab = -1;
        } else {
          this.toolTab = type;
        }

        if(type == 2){ //笔记
          let data = sessionStorage.getItem('study_catalog')?JSON.parse(sessionStorage.getItem('study_catalog')):null
          this.$refs.programming_note.getNoteList(data)
        }

      },
      /** 轴挪动 */
      lineMove(ev) {
        let that = this;
        let screenX = ev.screenX;
        let refWidth = that.$refs.programming_left.offsetWidth;
        this.isDrag = true;
        document.body.style.userSelect = 'none'
        const iframe = document.querySelector('iframe')
        iframe.style.pointerEvents = 'none'
        document.body.onmousemove = e => {
          let width = e.screenX - screenX + refWidth
          that.$set(that.leftDivStyle, 'width', width + 'px');
          that.leftWidth = width + 'px';
          that.$forceUpdate();
        };
        window.onmouseup = () => {
          this.onmouseup()
        };
      },
      onmouseup() {
        console.log('执行onmouseup')
        this.isDrag = false;
        document.body.style.userSelect = 'text'
        document.body.onmousemove = null;
        const iframe = document.querySelector('iframe')
        iframe.style.pointerEvents = 'auto'
      },
      // 选中导入的文件，传给组件
      handleImport(url) {
        this.$downloadFun(url)
      },
      activeThisOne(item, index) {
        this.activeIndex = index;
        this.activeOne = item;
      },
      prev() {
        if (this.activeIndex == 0) return
        this.activeIndex -= 1;
        this.activeOne = this.treeData[this.activeIndex];
      },
      next() {
        if (this.activeIndex == this.treeData.length - 1) return
        this.activeIndex += 1;
        this.activeOne = this.treeData[this.activeIndex];
      },
      /* 出发iframe内评分，传入参数 */
      postMessage() {

        let b = false,
          params = {
            business: {
              "questionId": this.questionId,
              "userId": sessionStorage.getItem('userId'),
            },
            events: [{
              "scoreType": 1,
              "eventWeight": 0.8,
              "formName": "",
              "formMapper": {},
              "uuid": "",
              "stand": {
                "aggrementMapper": {},
                "weightMapper": {},
                "unit": {}
              }
            }],
          };
        [].forEach.call(this.answer, item => {
          if (this.activeOne.event === item.timestamp) {
            this.$set(this.activeOne, 'value', item);
            this.$set(this.activeOne, 'itData', item.value.itData);
            this.treeData.splice(this.activeIndex, 1, this.activeOne);
            this.activeNames.push(this.activeIndex);
          }
        });
        if (this.activeOne.value && this.activeOne.itData) {
          params.events[0].eventWeight = this.activeOne.value.eventWeight;
          params.events[0].uuid = this.activeOne.value.timestamp;
          params.events[0].formName = this.activeOne.value.value.formName;
          params.events[0].formMapper = this.activeOne.value.timestamp;
          if (this.activeOne.itData.length && this.activeOne.itData[0].agreementList && this.activeOne.itData[0].agreementList.length) {
            b = true;
            [].forEach.call(this.activeOne.itData, (ititem, itindex) => {
              [].forEach.call(ititem.agreementList, (agreementItem, agreementIndex) => {
                let key = itindex + '_' + agreementIndex;
                params.events[0].stand.aggrementMapper[key] = agreementItem.aggrement;
                params.events[0].stand.weightMapper[key] = agreementItem.weight;

                if (this.platform === "jupyterNoteBook") {
                  params.events[0].stand.unit[key] = {
                    "compareContext": agreementItem.value.split('‼'),
                    compareTo: agreementItem.compareTo
                  }
                } else {
                  if (agreementItem.aggrement == 1 || agreementItem.aggrement == 2) {
                    params.events[0].stand.unit[key] = agreementItem.value.split('‼');
                  } else {
                    params.events[0].stand.unit[key] = {
                      "compareContext": agreementItem.value.split('‼'),
                      "filePath": agreementItem.path,
                    }
                  }
                }
              })
            })

          }
        }
        // 初始化iframe。
        if (b) {
          if (this.iframeLoading) return this.$message.warning("加载中，请稍等！");
          this.loading = true;
          let iframe = this.$refs.OSiframe;
          if (iframe && iframe.contentWindow) {
            let iframeWin = iframe.contentWindow; // process.env.RESOURSE_URL
            iframeWin.postMessage({gxzl: true, type: 'score', params}, this.iframeAddress);
          }
        } else {
          if (this.isEnd) {
            this.stepWeight = 0;
            let num = 0;
            for (const resKey in this.score) {
              num += this.score[resKey]
            }
            if (num) {
              this.stepWeight = num / 100 * 5;
              this.rateRefresh = !this.rateRefresh;
            } else {
              this.$messageSuccess('已完成')
            }

          } else {
            this.next();
          }

        }

      },
      /* 评分返回数据的处理 */
      resultScore(res) {
        let rightNumber = 0;
        let errorNumber = 0;
        if (
          res.data &&
          res.data.length &&
          this.answer.length
        ) {
          if (res.data[0].unit) {
            [].forEach.call(res.data[0].unit, item => {
              if (item.unitWeight) {
                rightNumber++
              } else {
                errorNumber++
              }
              let key = item.unitName.split('_');
              let itIndex = key[0]
              let agreementIndex = key[1];
              if (this.activeOne.itData) {
                this.$set(this.activeOne.itData[itIndex].agreementList[agreementIndex], 'unitWeight', item.unitWeight);
              }

              this.$set(this.activeOne, 'rightNumber', rightNumber);
              this.$set(this.activeOne, 'errorNumber', errorNumber);
            })
          }
          if (res.data[0].formMapper) {
            this.score[res.data[0].formMapper] = res.data[0].stepWeight
          }
        }
        this.eventScoring = true;
        if (this.isEnd) {
          this.stepWeight = 0;
          let num = 0;
          for (const resKey in this.score) {
            num += this.score[resKey]
          }
          this.stepWeight = num * 5 / 100;
          this.rateRefresh = !this.rateRefresh;
          // this.timer = setTimeout(() => {
          //   this.toolTab = 1;
          // }, 6000)
        } else {
          if (errorNumber === 0) this.next();
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      nextSection() {
        this.$router.go(-1);
      }
    }
  }
</script>

<style scoped lang="scss">

  .programming {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;


    .courseSubBtn {
      height: 32px;
      line-height: 32px;
      border-radius: 6px;
    }

    /* 左侧 */
    .programming_left {
      min-width: 58px;

      .header {
        height: 40px;
        background: rgba(24, 144, 255, 0.08);
        font-family: PingFangSC-Medium, PingFang SC;
        color: #42414D;
        display: flex;
        align-items: center;

        .el-icon-back {
          margin: 0 22px;
          font-weight: 600;
          font-size: 20px;
          cursor: pointer;
        }
      }

      .bottomer {
        height: calc(100% - 40px);
        position: relative;

        .nava {
          height: 100%;
          background: #ffffff;
          position: absolute;
          top: 0;
          left: 0;
          box-shadow: 5px 0px 8px 0px rgba(17, 17, 17, 0.06);
          display: flex;
          z-index: 20;

          .nava_tool {
            user-select: none;
            width: 58px;
            box-shadow: 5px 0px 5px 0px rgba(17, 17, 17, 0.04);

            p {
              text-align: center;
              margin: 15px 0;
              padding: 10px 0;
              color: #999999;
              cursor: pointer;
            }

            .activeP {
              background: rgba(83, 151, 247, 0.09);
              border-radius: 0px 6px 6px 0px;
              border-left: solid 2px #1890FF;
              color: #1890FF;
            }

            .nava_label {
              display: block;
              margin-top: 5px;
              font-size: 13px;
              font-family: PingFangSC-Medium, PingFang SC;
            }
          }

          .nava_menu {
            .rateBox {
              padding: 16px;
              display: flex;
              line-height: 25px;

              /deep/ .el-rate {
                height: auto;
                line-height: initial;

                .el-rate__icon,
                .el-rate__decimal,
                .el-icon-star-on {
                  font-size: 20px;
                }
              }
            }

            .nava_menu_style {
              height: calc(100% - 32px);
              overflow-y: auto;
              padding: 16px;

              p {
                /*margin: 10px;*/
                line-height: 36px;
                display: flex;
                align-items: center;
                cursor: pointer;
              }
            }
          }

          .nava_menu, .nava_note {
            height: 100%;
            width: 0px;
            overflow: hidden;
            transition: all 0.3s ease;
            box-shadow: 5px 0px 8px 0px rgba(17, 17, 17, 0.06);
          }

          .activeNava {
            width: 300px;
          }

        }

        .content {
          height: 100%;
          margin-left: 58px;
          display: flex;
          flex-direction: column;

          .content_header {
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .text_content {
            flex: 1;
            overflow-y: auto;
            border-top: solid 1px #e5e5e5;
            border-bottom: solid 1px #e5e5e5;
            padding: 10px;


            .type6Item {
              margin-bottom: 7px;
              width: 100%;
              overflow: hidden;

              .ql-editor {
                /deep/ img {
                  max-width: 90%;
                  display: block;
                }
              }
            }

            .type6resouce {
              display: inline-block;
              max-width: 100%;
            }

          }

          /* 事项评分 */
          .eventScoring {
            position: relative;
            left: 0;
            width: 100%;
            bottom: 0;

            .eventScoringL {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              background: #E6E8F1;
              border-radius: 4px 4px 0px 0px;
              padding: 0px 8px;
              top: -15px;
              cursor: pointer;
              height: 15px;
              width: 48px;
              text-align: center;
              z-index: 18;
            }


            .eventScoringContent {
              height: 0px;
              overflow: hidden;
              transition: all 0.3s ease;
              box-shadow: 0px -4px 4px 0px rgba(194, 189, 189, 0.22), 0px 1px 0px 0px rgba(0, 0, 0, 0.5);

              .eventScoringHead {
                height: 23px;
                background: #F5F5F7;
                text-align: right;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                .eventScoringHeadItem {
                  padding: 0 10px;
                  display: flex;
                  align-items: center;
                }

                .eventScoringHeadNumber {
                  font-size: 12px;
                  color: #42414D;
                  padding-left: 3px;
                }
              }
            }

            .eventScoringShow {
              height: auto;
              min-height: 100px;
              max-height: 400px;
              overflow-y: auto;
              transition: all 0.3s ease;
            }
          }

          .content_footer {
            height: 40px;
            line-height: 38px;
            text-align: center;
            user-select: none;

            .skip {
              font-size: 12px;
              color: #cccccc;
              cursor: pointer;
            }

            .nextSection {
              font-size: 12px;
              color: #1890FF;
              cursor: pointer;
            }
          }
        }

        .bottomerMask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.49);
          z-index: 19;
        }


        .item_label {
          font-size: 14px;
          color: #42414D;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .activeRound {
          color: #1890FF;

          .item_activeRound {
            background: #1890FF;
            color: #ffffff;
            display: inline-block;
            border-radius: 16px;
            width: 16px;
            height: 16px;
            line-height: 15px;
            text-align: center;
            font-size: 11px;
            margin-right: 5px;
          }
        }
      }

      .item_round {
        display: inline-block;
        border-radius: 16px;
        width: 16px;
        height: 16px;
        line-height: 15px;
        text-align: center;
        background: #DCE0E9;
        color: #B6B6BB;
        font-size: 11px;
        margin-right: 5px;
      }

      .agreementP {
        padding: 0 10px;
        height: 44px;
        font-weight: 500;
        color: #42414D;
        display: flex;
        font-size: 12px;
        align-items: center;
        justify-content: space-between;

        .yuanqiu {
          display: inline-block;
          width: 16px;
          height: 16px;
          font-size: 12px;
          border-radius: 16px;
          text-align: center;
          line-height: 16px;
          background: rgba(24, 144, 255, 0.04);
          color: #1890FF;
        }
      }
    }

    /* 右侧 */
    .programming_right {
      flex: 1;
      position: relative;

      .programming_right_mask {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 20000;
      }
      .toolsSet {
        position: absolute;
        text-align: center;
        top: 0;
        right: 0;
        z-index: 2010;
        background: #e5e5e5;
        span {
          cursor: pointer;
          font-size: 20px;
          display: block;
          width: 30px;
          height: 30px;
          text-align: center;
          line-height: 30px;

          &:hover {
            background: white;
          }
        }

        .toolsShowStyle {
          display: flex;
          flex-direction: column;
        }
      }
    }

    /* 拖拽线 */
    .programming_line {
      width: 0px;
      height: 100%;
      position: relative;

      .code_line_icon {
        cursor: ew-resize;
        padding: 0px 8px;
        position: absolute;
        background: rgba(24, 144, 255, 0.2);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(90deg);
        z-index: 1000;

        &:hover {
          background: rgba(24, 144, 255, 0.5);

          svg {
            fill: #ffffff;
          }
        }
      }

      svg {
        fill: #1890FF;
      }
    }
  }
</style>
<style>
  .programming .el-collapse-item__content {
    padding-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/Learning_details/programming.vue